import { useQuery } from '@tanstack/react-query'

import { apiGetOpenWaitlist } from '@/apis/serviceArea/getOpenWaitlist'

import { SERVICE_AREA_KEYS } from '../keys/serviceArea'

interface UseGetOpenWaitlistParams {
  /** 조회할 주소. 빈 값이면 쿼리 비활성 */
  address: string | null
}

/**
 * 오픈 알림 신청 현황 조회 훅.
 *
 * address가 결정되기 전(예: 결과 화면 진입 전)에는 enabled=false.
 * POST mutation 성공 시 같은 키로 invalidate되어 자동 refetch.
 */
export const useGetOpenWaitlist = ({ address }: UseGetOpenWaitlistParams) => {
  return useQuery({
    queryKey: [SERVICE_AREA_KEYS.WAITLIST_STATUS, address],
    queryFn: () => apiGetOpenWaitlist({ address: address! }),
    enabled: !!address,
  })
}
